import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
// import ImageWithBasePath from '../../core/img/imagewithbasebath';
import {
  RotateCw,
  ShoppingCart,
} from "feather-icons-react/build/IconComponents";
import { Check, Trash2 } from "react-feather";
import Select from "react-select";
import PlusCircle from "feather-icons-react/build/IconComponents/PlusCircle";
import MinusCircle from "feather-icons-react/build/IconComponents/MinusCircle";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import {
  API_BASE_URL,
  GET_CATEGORIES_ITEMS,
  GET_VSTORE_PROD,
  GET_TAXES_DATA,
  GET_PAYMENTS_TYPES,
  IMAGE_URL_IBIZ,
  INSERT_ORDERS,
  GET_CUSTOMERS,
} from "../../Config";
import AllCategoryImage from "./categories.png";
import SpinLoader from "../loader/SpinLoader";
import AddCustomerModal from "./Addcustomermodal";
const Pos = () => {
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [userDataSession, setUserDataSession] = useState({});
  const [categoriesData, setCategoriesData] = useState([]);
  const [catLoadingData, setCatLoadingData] = useState(true);
  const [productsList, setProductsList] = useState([]);
  const [taxesData, setTaxesData] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [selectedCatId, setSelectedCatId] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCusId, setSelectedCusId] = useState(null);
  const [customersDDL, setCustomersDDL] = useState([]);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [notes, setNotes] = useState("");
  const [expectedDate, setExpectedDate] = useState("");
  const [payments, setPayments] = useState([]);
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState("");
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);

  const [fullProducts, setFullProducts] = useState([]);
  const [barcodeInput, setBarcodeInput] = useState("");
  // const timerRef = useRef(null);
  const [isAddCustomerOpen, setIsAddCustomerOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 12;

  const styles = {
    // imagePlaceholder: {
    //   width: "3rem",
    //   height: "3rem",
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   borderRadius: "50%",
    //   fontSize: "20px",
    //   color: "#fff",
    //   backgroundColor: "#FF9F43",
    // },
    // productImage: {
    //   width: "3rem",
    //   height: "3rem",
    //   objectFit: "cover",
    // },
    // productInfo: {
    //   display: "flex",
    //   flexDirection: "column",
    //   alignItems: "flex-start",
    //   justifyContent: "center",
    //   minHeight: "4rem",
    //   paddingLeft: "10px",
    // },
    barcodeText: {
      fontSize: "0.85rem",
      color: "#FFFFFF",
      fontWeight: "900",
    },
    productTitle: {
      margin: 0,
      fontSize: "13px",
      fontWeight: "bold",
    },
    productPrice: {
      margin: 0,
      fontSize: "12px",
      // color: '#333',
    },
  };
  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  // const handleKeyPress = (e) => {
  //   if (e.key.length === 1) {
  //     setBarcode((prev) => prev + e.key);
  //   }
  //   if (timerRef.current) clearTimeout(timerRef.current);
  //   timerRef.current = setTimeout(() => {
  //     if (barcode) {
  //       const localProduct = productsList.find((p) => p.BarCode === barcode);
  //       if (localProduct) {
  //         handleProductSelect({
  //           value: localProduct.Id,
  //           label: localProduct.ProductName,
  //           price: localProduct.MRP,
  //           barcode: localProduct.BarCode,
  //           imagePath: localProduct.ImagePath,
  //           taxId: localProduct.TaxId,
  //           inclusive: localProduct.PriceInclusiveTax,
  //         });
  //       } else {
  //         MySwal.fire(
  //           "Not Found",
  //           "Product not found for this barcode.",
  //           "warning",
  //         );
  //       }
  //       setBarcode("");
  //     }
  //   }, 300);
  // };
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    // const customersdata = JSON.parse(
    //   sessionStorage.getItem("filteredDDLData_Customers")
    // );
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      // setCustomersDDL(customersdata || []);
    } else {
      navigate("/");
    }
  }, [navigate]);
  useEffect(() => {
    if (userDataSession?.OrgId) {
      setCatLoadingData(true);
      axios
        .get(
          `${API_BASE_URL}${GET_CATEGORIES_ITEMS}?OrgId=${userDataSession.OrgId}`,
        )
        .then((res) => {
          if (res.data.Status) {
            setCategoriesData(res.data.ResultData);
          }
        })
        .catch((err) => console.error(err))
        .finally(() => setCatLoadingData(false));
      axios
        .get(`${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`)
        .then((res) => {
          if (res.data.Status) {
            const formatted = res.data.ResultData.map((t) => ({
              value: t.Id,
              label: `GST ${t.TaxRate}%`,
              rate: t.TaxRate,
              sgst: t.SGSTRate,
              cgst: t.CGSTRate,
              igst: t.IGSTRate,
            }));
            setTaxesData(formatted);
          }
        })
        .catch((err) => console.error(err));
      axios
        .get(
          `${API_BASE_URL}${GET_PAYMENTS_TYPES}?OrgId=${userDataSession.OrgId}`,
        )
        .then((res) => {
          if (res.data.Status) {
            setPaymentTypes(res.data.ResultData);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [userDataSession]);

  const refetchCustomers = () => {
    axios
      .get(
        `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession.OrgId}&CustomerId=0`,
      )
      .then((res) => {
        if (res.data.Status) setCustomersDDL(res.data.ResultData || []);
      });
  };

  useEffect(() => {
    if (userDataSession?.OrgId) {
      refetchCustomers();
    }
  }, [userDataSession]);

  console.log(customersDDL, "customer Data");
  useEffect(() => {
    if (
      !userDataSession?.OrgId ||
      !userDataSession?.UserId ||
      fullProducts.length > 0
    ) {
      return;
    }

    setLoading(true);

    const payload = {
      OrgId: userDataSession.OrgId,
      CategoryId: 0, // ← fetch ALL products
      BarCode: "0",
      ProductId: 0,
      StoreId: userDataSession.StoreId,
      IsForSale: 1,
      UserId: userDataSession.UserId,
      Type: 1,
    };

    axios
      .post(`${API_BASE_URL}${GET_VSTORE_PROD}`, payload)
      .then((res) => {
        if (res.data.Status) {
          const all = res.data.ResultData || [];
          setFullProducts(all);
          setProductsList(all); // initial grid = all products
        }
      })
      .catch((err) => console.error("Load products failed:", err))
      .finally(() => setLoading(false));
  }, [userDataSession]);

  useEffect(() => {
    if (fullProducts.length === 0) return;

    if (selectedCatId === 0) {
      setProductsList(fullProducts);
    } else {
      const filtered = fullProducts.filter(
        (p) => String(p.CategoryId) === String(selectedCatId), // adjust field name if needed
      );
      setProductsList(filtered);
    }

    setCurrentPage(1);
  }, [selectedCatId, fullProducts]);
console.log(fullProducts, "full products");

  const productDropdownOptions = React.useMemo(() => {
    return fullProducts.map((item) => ({
      value: item.Id,
      label: item.ProductName,
      data: {
        value: item.Id,
        label: item.ProductName,
        price: item.MRP,
        barcode: item.BarCode,
        imagePath: item.ImagePath,
        taxId: item.TaxId,
        inclusive: item.PriceInclusiveTax,
      },
    }));
  }, [fullProducts]);

  const handleProductSelect = (product) => {
    setSelectedProducts((prev) => {
      const exists = prev.find((p) => p.value === product.value);
      if (exists) {
        return prev.map((p) =>
          p.value === product.value ? { ...p, quantity: p.quantity + 1 } : p,
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };
  const processBarcode = (code) => {
    const localProduct = productsList.find(
      (p) => p.BarCode?.trim() === code, // strict match
      // or more forgiving: p.BarCode?.trim().toUpperCase() === code.trim().toUpperCase()
    );

    if (localProduct) {
      handleProductSelect({
        value: localProduct.Id,
        label: localProduct.ProductName,
        price: localProduct.MRP,
        barcode: localProduct.BarCode,
        imagePath: localProduct.ImagePath,
        taxId: localProduct.TaxId,
        inclusive: localProduct.PriceInclusiveTax,
      });
      // Optional: success feedback
      // MySwal.fire({ title: "Added", text: localProduct.ProductName, icon: "success", toast: true, timer: 1500, position: "top-end" });
    } else {
      MySwal.fire("Not Found", `No product with barcode: ${code}`, "warning");
    }

    setBarcodeInput("");
    inputRef.current?.focus();
  };

  const handleIncrement = (index) => {
    setSelectedProducts((prev) =>
      prev.map((p, i) =>
        i === index ? { ...p, quantity: p.quantity + 1 } : p,
      ),
    );
  };
  const handleDecrement = (index) => {
    setSelectedProducts((prev) =>
      prev.map((p, i) => {
        if (i === index && p.quantity > 1)
          return { ...p, quantity: p.quantity - 1 };
        return p;
      }),
    );
  };
  const handleDeleteProduct = (index) => {
    setSelectedProducts((prev) => prev.filter((_, i) => i !== index));
  };
  const handleClearAll = () => {
    MySwal.fire({
      title: "Clear All?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((res) => {
      if (res.isConfirmed) {
        setSelectedProducts([]);
        setAdvanceAmount(0);
        setPayments([]);
        setCurrentPaymentAmount("");
        setSelectedPaymentType(null);
      }
    });
  };
  const calculateAmounts = () => {
    let subtotal = 0;
    let totalTax = 0;
    let sgstTotal = 0;
    let cgstTotal = 0;
    let igstTotal = 0;
    selectedProducts.forEach((p) => {
      const lineSub = p.price * p.quantity;
      subtotal += lineSub;
      let lineSgst = 0;
      let lineCgst = 0;
      let lineIgst = 0;
      if (!p.inclusive) {
        const tax = taxesData.find((t) => t.value === p.taxId);
        if (tax) {
          lineSgst = lineSub * (tax.sgst / 100);
          lineCgst = lineSub * (tax.cgst / 100);
          lineIgst = lineSub * (tax.igst / 100);
        }
      }
      sgstTotal += lineSgst;
      cgstTotal += lineCgst;
      igstTotal += lineIgst;
      totalTax += lineSgst + lineCgst + lineIgst;
    });
    const finalTotal = subtotal + totalTax;
    return { subtotal, totalTax, sgstTotal, cgstTotal, igstTotal, finalTotal };
  };
  const amounts = calculateAmounts();
  const totalPaid = payments.reduce((sum, p) => sum + p.PaidAmount, 0);
  const remainingAmount = amounts.finalTotal - totalPaid;
  const handlePaymentTypeChange = (selectedOption) => {
    setSelectedPaymentType(selectedOption ? selectedOption.value : null);
  };
  const handleAddPayment = () => {
    const amt = parseFloat(currentPaymentAmount);
    if (!isNaN(amt) && amt > 0 && selectedPaymentType) {
      const existingIndex = payments.findIndex(
        (p) => p.PaymentTypeId === selectedPaymentType,
      );
      if (existingIndex !== -1) {
        const updated = [...payments];
        updated[existingIndex].PaidAmount += amt;
        setPayments(updated);
      } else {
        setPayments([
          ...payments,
          {
            PaymentTypeId: selectedPaymentType,
            PaidAmount: amt,
            CardNo: "",
            MobileNo: "",
          },
        ]);
      }
      setCurrentPaymentAmount("");
    } else {
      MySwal.fire(
        "Invalid",
        "Enter valid amount and select payment type",
        "warning",
      );
    }
  };
  const handleRemovePayment = (index) => {
    setPayments(payments.filter((_, i) => i !== index));
  };
  const buildEstimatePayload = () => {
    const { finalTotal, sgstTotal, cgstTotal, igstTotal } = amounts;
    const finalNotes = notes?.trim() || "";
    const deliveryDate =
      expectedDate ||
      new Date(Date.now() + 86400000).toISOString().split("T")[0];
    return {
      orgid: userDataSession?.OrgId,
      userid: userDataSession?.UserId,
      Quotaion: {
        StoreId: userDataSession?.StoreId,
        PosId: 0,
        Total: finalTotal,
        Discounts: 0,
        SGSTS: sgstTotal,
        CGSTS: cgstTotal,
        IGSTS: igstTotal,
        Status: 1,
        IsActive: 1,
        Quotaiondate: new Date().toISOString(),
        DiscountId: 0,
        DiningId: 0,
        ReturnFromOrdId: 0,
        CustomerId: selectedCusId || 0,
        PriceListId: 0,
        ExpectedDelivery: deliveryDate,
        Notes: finalNotes,
        AdvanceAmount: Number(advanceAmount),
      },
      QuotaionDetails: selectedProducts.map((p) => {
        const lineSub = p.price * p.quantity;
        let sgst = 0;
        let cgst = 0;
        let igst = 0;
        let sgstrate = 0;
        let cgstrate = 0;
        let igstrate = 0;
        if (!p.inclusive) {
          const tax = taxesData.find((t) => t.value === p.taxId);
          if (tax) {
            sgst = lineSub * (tax.sgst / 100);
            cgst = lineSub * (tax.cgst / 100);
            igst = lineSub * (tax.igst / 100);
            sgstrate = tax.sgst;
            cgstrate = tax.cgst;
            igstrate = tax.igst;
          }
        }
        return {
          ProductId: p.value,
          Quantity: p.quantity,
          UnitPrice: p.price,
          Discount: 0,
          SGST: sgst,
          CGST: cgst,
          IGST: igst,
          CGSTrate: cgstrate,
          SGSTrate: sgstrate,
          IGSTrate: igstrate,
          Total: p.inclusive ? lineSub : lineSub + sgst + cgst + igst,
          Status: 1,
          RefundQuantity: 0,
          IsActive: 1,
          VendorId: 0,
          IsComplement: 0,
          Barcode: p.barcode || "",
        };
      }),
    };
  };
  const handleAdvanceBooking = () => {
    if (!selectedCusId) {
      MySwal.fire("Invalid", "Please Select Customer");
    }
    if (!advanceAmount || isNaN(advanceAmount) || Number(advanceAmount) <= 0) {
      MySwal.fire("Invalid", "Enter valid advance amount", "warning");
      return;
    }
    if (selectedProducts.length === 0) {
      MySwal.fire("Empty", "Add products first", "warning");
      return;
    }

    const advance = parseFloat(advanceAmount);
    if (!advance || advance <= 0) {
      MySwal.fire("Invalid", "Enter valid advance amount", "warning");
      return;
    }
    if (selectedProducts.length === 0) {
      MySwal.fire("Empty", "Add products first", "warning");
      return;
    }
    setLoading(true);
    const payload = buildEstimatePayload();
    axios
      .post(`${API_BASE_URL}Billing/SaveQuotaionDetails`, payload)
      .then((res) => {
        if (res.data && res.data[0]?.QuotaionId) {
          MySwal.fire({
            icon: "success",
            title: "Advance Booked!",
            text: `Estimate #${res.data[0].QuotaionId} created with ₹${advance} advance.`,
          }).then(() => {
            setSelectedProducts([]);
            setAdvanceAmount(0);
            setSelectedCusId(null);
            setNotes("");
            setExpectedDate("");
            setPayments([]);
            setCurrentPaymentAmount("");
            setSelectedPaymentType(null);
          });
        } else {
          throw new Error("Invalid response");
        }
      })
      .catch((err) => {
        MySwal.fire(
          "Error",
          err.response?.data?.error?.message || "Failed to book advance",
          "error",
        );
      })
      .finally(() => setLoading(false));
  };
  const handlePlaceOrder = async () => {
    if (!selectedCusId) {
      MySwal.fire("Invalid", "Please Select Customer");
    }
    if (selectedProducts.length === 0) {
      MySwal.fire("Empty Cart", "Add at least one product", "warning");
      return;
    }
    const { finalTotal, sgstTotal, cgstTotal, igstTotal } = amounts;
    const payload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      OrgType: 0,
      BillNo: null,
      Order: {
        StoreId: userDataSession.StoreId || 5,
        PosId: 0,
        OrderType: 1,
        Total: finalTotal,
        Discount: 0,
        SGST: sgstTotal,
        CGST: cgstTotal,
        IGST: igstTotal,
        Status: 1,
        IsActive: 1,
        Orderdate: new Date().toISOString(),
        DiscountId: 0,
        DiningId: 0,
        ReturnFromOrdId: 0,
        CustomerId: selectedCusId || 0,
        PriceListId: 0,
        TransportMode: "NULL",
        TransportvehicleNumber: "NULL",
        AdditionalCharges: 0,
        AdditionalRoundOffAmount: 0,
        IsAcknowledge: 0,
        TransportAmount: 0,
        InvoiceNo: "NULL",
        EmpId: userDataSession?.UserId,
      },
      OrderDetails: selectedProducts.map((prod) => {
        const lineSub = prod.price * prod.quantity;
        let sgst = 0;
        let cgst = 0;
        let igst = 0;
        let sgstrate = 0;
        let cgstrate = 0;
        let igstrate = 0;
        if (!prod.inclusive) {
          const tax = taxesData.find((t) => t.value === prod.taxId);
          if (tax) {
            sgst = lineSub * (tax.sgst / 100);
            cgst = lineSub * (tax.cgst / 100);
            igst = lineSub * (tax.igst / 100);
            sgstrate = tax.sgst;
            cgstrate = tax.cgst;
            igstrate = tax.igst;
          }
        }
        return {
          ProductId: prod.value,
          Quantity: prod.quantity,
          UnitPrice: prod.price,
          Discount: 0,
          SGST: sgst,
          CGST: cgst,
          IGST: igst,
          Total: prod.inclusive ? lineSub : lineSub + sgst + cgst + igst,
          Status: 1,
          RefundQuantity: 0,
          IsActive: 1,
          VendorId: 0,
          IsComplement: 0,
          CGSTrate: cgstrate,
          SGSTrate: sgstrate,
          IGSTrate: igstrate,
          NoOfBags: 0,
          Comments: notes?.trim() || "",
          ItemWeight: 1,
          ItemPackingWeight: 0,
          BilledBarCode: prod.barcode || "NULL",
        };
      }),
      OrderAdditionalDetails: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        MakingCharges: 0,
        OtherCharges: 0,
        MetalRateId: 0,
      })),
      OrderPayments: payments.map((p) => ({
        PaymentTypeId: p.PaymentTypeId,
        PaidAmount: p.PaidAmount,
        CardNo: p.CardNo || "",
        MobileNo: p.MobileNo || "",
      })),
      StockHistory: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId || 5,
        StockEffectTypeId: 2,
        StockAdjusted: prod.quantity,
        TransactionId: 0,
        TransfarStockId: 0,
        StockAdjustId: 0,
        IsActive: 1,
        SupplierId: 0,
      })),
      StoreProducts: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId || 5,
        StockAdjusted: -prod.quantity, // Deduct stock
      })),
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}${INSERT_ORDERS}`,
        payload,
      );
      const data = response.data;
      if (data && data[0]?.OrderId >= 1) {
        MySwal.fire({
          icon: "success",
          title: "Order Placed!",
          text: `Order #${data[0].OrderId} created successfully.`,
          timer: 3000,
        }).then(() => {
          setSelectedProducts([]);
          setAdvanceAmount(0);
          setNotes("");
          setExpectedDate("");
          setSelectedCusId(null);
          setPayments([]);
          setCurrentPaymentAmount("");
          setSelectedPaymentType(null);
        });
      } else {
        throw new Error("Invalid response");
      }
    } catch (err) {
      console.error("Place Order Error:", err);
      MySwal.fire(
        "Error",
        err.response?.data?.[0]?.ResultMessage || "Failed to place order",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };
  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 500,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
      { breakpoint: 400, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <>
      {loading && <SpinLoader />}
      <div className="page-wrapper pos-pg-wrapper ">
        <div className="conten pos-design p-0 bg-white">
          {/* Header */}
          <div className="btn-row d-sm-flex align-items-center">
            <Link to="/advance-booking" className="btn btn-secondary ">
              <ShoppingCart className="feather-16 me-2" /> View Bookings
            </Link>
            <Link to="/sales-list" className="btn btn-primary">
              View Orders
            </Link>
            <Link
              to="#"
              className="btn btn-info d-none"
              onClick={handleClearAll}
            >
              <RotateCw className="feather-16" /> Reset
            </Link>
            <div className="d-flex col-3" style={{ marginLeft: "auto" }}>
              <div style={{ position: "relative" }}>
                <i
                  className="fa-solid fa-barcode"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                  }}
                />
                <input
                  ref={inputRef}
                  type="text"
                  className="form-control"
                  placeholder="Scan barcode..."
                  value={barcodeInput}
                  onChange={(e) => setBarcodeInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // prevent form submit etc.
                      const code = barcodeInput.trim();
                      if (code) {
                        processBarcode(code);
                      }
                      setBarcodeInput(""); // clear immediately
                      inputRef.current?.focus(); // ready for next scan
                    }
                  }}
                  style={{ paddingLeft: "35px" }}
                />
              </div>
            </div>
          </div>
          <div className="row align-items-start pos-wrapper">
            <div className="col-lg-8">
              <div className="pos-categories">
                {catLoadingData ? (
                  <p>Loading categories...</p>
                ) : (
                  <Slider {...settings}>
                    <div
                      className="pos-slick-item card m-0"
                      onClick={() => setSelectedCatId(0)}
                    >
                      <div className="card-body text-center">
                        <img
                          src={AllCategoryImage}
                          className="m-auto d-flex text-center "
                          alt="All"
                          style={{
                            width: "3rem",
                            height: "3rem",
                            borderRadius: "10px",
                          }}
                        />
                        <h6>All Categories</h6>
                        <span className="text-info fw-bold">
                          {categoriesData.reduce(
                            (total, category) => total + category.ProductCount,
                            0,
                          )}{" "}
                          Items{" "}
                        </span>
                      </div>
                    </div>
                    {categoriesData.map((cat) => (
                      <div
                        key={cat?.CategoryId}
                        id={`headphones${cat?.CategoryId}`}
                        className="pos-slick-item card"
                        onClick={() => setSelectedCatId(cat.CategoryId)}
                      >
                        <div className="card-body text-center">
                          <img
                            src={`${IMAGE_URL_IBIZ}${cat.ImagePath}`}
                            alt={cat.Name}
                            style={{
                              width: "3rem",
                              height: "3rem",
                              borderRadius: "10px",
                            }}
                          />
                          <h6>{cat.Name}</h6>
                          <span className="text-info">
                            {cat.ProductCount} Items
                          </span>
                        </div>
                      </div>
                    ))}
                  </Slider>
                )}
              </div>
              <div className="pos-products">
                {/* Search + Title Bar */}
                <div className="d-flex align-items-center justify-content-between mb-3 px-2">
                  <h5 className="mb-0">Products</h5>

                  <input
                    type="text"
                    className="form-control w-25"
                    placeholder="Search by name "
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1); // reset to page 1 when search changes
                    }}
                  />
                </div>

                {/* Products Grid + Pagination */}
                <div style={{ maxHeight: "60rem", overflowY: "auto" }}>
                  {loading ? (
                    <div className="text-center py-5">
                      <SpinLoader />
                    </div>
                  ) : (
                    (() => {
                      // 1. Filter products
                      const filtered = productsList.filter(
                        (item) =>
                          item.ProductName?.toLowerCase().includes(
                            searchTerm.toLowerCase(),
                          ) ||
                          item.BarCode?.toLowerCase().includes(
                            searchTerm.toLowerCase(),
                          ),
                      );

                      // 2. Calculate pagination
                      const totalProducts = filtered.length;
                      const totalPages = Math.ceil(
                        totalProducts / productsPerPage,
                      );
                      const indexOfLast = currentPage * productsPerPage;
                      const indexOfFirst = indexOfLast - productsPerPage;
                      const currentProducts = filtered.slice(
                        indexOfFirst,
                        indexOfLast,
                      );

                      return (
                        <>
                          {/* Products grid */}
                          <div className="row">
                            {currentProducts.length === 0 && searchTerm ? (
                              <div className="col-12 text-center py-5 text-muted">
                                <h6>No products found matching {searchTerm}</h6>
                              </div>
                            ) : currentProducts.length === 0 ? (
                              <div className="col-12 text-center py-5 text-muted">
                                <h6>No products in this category</h6>
                              </div>
                            ) : (
                              currentProducts.map((item) => (
                                <div
                                  key={item.Id}
                                  className="col-sm-6 col-md-4 col-lg-3 mb-3"
                                  onClick={() =>
                                    handleProductSelect({
                                      value: item.Id,
                                      label: item.ProductName,
                                      price: item.MRP,
                                      barcode: item.BarCode,
                                      imagePath: item.ImagePath,
                                      taxId: item.TaxId,
                                      inclusive: item.PriceInclusiveTax,
                                    })
                                  }
                                >
                                  <div
                                    className="product-info card"
                                    style={{
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Link
                                      to="#"
                                      className="img-bg"
                                      style={{ flex: "0 0 auto" }}
                                    >
                                      {item.ImagePath ? (
                                        <img
                                          src={`${IMAGE_URL_IBIZ}${item.ImagePath}`}
                                          alt={item?.ProductName}
                                          style={styles.productImage}
                                        />
                                      ) : (
                                        <div
                                          className="text-primary"
                                          style={styles.imagePlaceholder}
                                        >
                                          {item?.ProductName?.[0] || "?"}
                                        </div>
                                      )}
                                      <span>
                                        <Check className="feather-16" />
                                      </span>
                                    </Link>

                                    <div style={styles.productInfo}>
                                      <h6
                                        className="cat-name"
                                        style={styles.barcodeText}
                                      >
                                        <Link>{item.BarCode || "—"}</Link>
                                      </h6>
                                      <h6
                                        className="product-name"
                                        style={styles.productTitle}
                                      >
                                        {item.ProductName}
                                      </h6>
                                      <div
                                        className="price d-flex justify-content-between"
                                        style={{
                                          flex: "1",
                                          alignItems: "flex-end",
                                        }}
                                      >
                                        <span style={styles.productPrice}>
                                          {item.StockByUsers || 0} Pcs
                                        </span>
                                        <p style={styles.productPrice}>
                                          ₹{item.AvgPrice || item.MRP || "—"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>

                          {/* Pagination Controls */}
                          {totalPages > 1 && (
                            <div className="mt-4 px-2">
                              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                                <div className="text-muted small">
                                  Showing {indexOfFirst + 1}–
                                  {Math.min(indexOfLast, totalProducts)} of{" "}
                                  {totalProducts}
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() =>
                                      setCurrentPage((p) => Math.max(1, p - 1))
                                    }
                                    disabled={currentPage === 1}
                                  >
                                    Previous
                                  </button>

                                  <span className="fw-bold px-2">
                                    Page {currentPage} of {totalPages}
                                  </span>

                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() =>
                                      setCurrentPage((p) =>
                                        Math.min(totalPages, p + 1),
                                      )
                                    }
                                    disabled={currentPage === totalPages}
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })()
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-4 ps-0 ">
              <aside className="product-order-list pt-0">
                <div className="customer-info  mt-0 mb-0 pt-0">
                  <label>Customer</label>
                  <div className="input-block d-flex align-items-center">
                    <div className="flex-grow-1">
                      <Select
                        options={customersDDL?.map((c) => ({
                          value: c.Id,
                          label: c.Name,
                        }))}
                        // value={null}
                        onChange={(opt) => setSelectedCusId(opt.value)}
                        placeholder="Select Customer"
                      />
                    </div>
                   
                    <Link
                      to="#"
                      className="btn btn-primary btn-icon"
                      onClick={() => setIsAddCustomerOpen(true)}
                      // data-bs-toggle="modal"
                      // data-bs-target="#add-units"
                    >
                      <i className="fa-solid fa-user-plus"></i>
                    </Link>
                  </div>
                </div>
                 <div className="customer-info block-section mt-0 mb-0 pt-0">
                      <label>Products</label>
                      <Select
                        options={productDropdownOptions}
                        placeholder="Search & add product..."
                        isSearchable={true}
                        value={null}
                        onChange={(option) => {
                          if (option?.data) {
                            handleProductSelect(option.data);
                          }
                        }}
                        noOptionsMessage={() => "No products loaded"}
                      />
                    </div>
                <div className="product-added block-section">
                  <div className="head-text d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">
                      Items{" "}
                      <span className="badge bg-primary rounded-pill">
                        {selectedProducts.length}
                      </span>
                    </h6>
                    <Link
                      to="#"
                      className="text-danger small fw-medium"
                      onClick={handleClearAll}
                    >
                      <i className="feather feather-x me-1"></i> Clear All
                    </Link>
                  </div>
                  {/* Scrollable Cart Items */}
                  <div
                    className="cart-items-container"
                    style={{ maxHeight: "45vh", overflowY: "auto" }}
                  >
                    {selectedProducts.length === 0 ? (
                      <p className="text-center text-muted my-4">
                        No items in cart
                      </p>
                    ) : (
                      selectedProducts.map((item, i) => (
                        <div
                          key={i}
                          className="cart-item d-flex align-items-center justify-content-between p-3 mb-2 bg-light rounded shadow-sm"
                        >
                          {/* Product Info */}
                          <div className="flex-grow-1 me-3">
                            <h6 className="mb-1 fw-semibold text-dark">
                              {item.label}
                            </h6>
                            <p className="mb-0 text-info small">
                              ₹{item.price} × {item.quantity} ={" "}
                              <strong>
                                ₹{(item.price * item.quantity).toFixed(2)}
                              </strong>
                            </p>
                          </div>
                          {/* Quantity Controls */}
                          <div className="d-flex align-items-center gap-1">
                            <Link
                              className="btn btn-sm d-flex align-items-center justify-content-center p-1"
                              onClick={() => handleDecrement(i)}
                              title="Decrease"
                            >
                              <MinusCircle size={16} />
                            </Link>
                            <input
                              type="text"
                              value={item.quantity}
                              readOnly
                              className="form-control form-control-sm text-center mx-1"
                              style={{ width: 50 }}
                            />
                            <Link
                              className="btn btn-sm d-flex align-items-center justify-content-center p-1"
                              onClick={() => handleIncrement(i)}
                              title="Increase"
                            >
                              <PlusCircle size={16} />
                            </Link>
                            {/* Delete */}
                            <Link
                              className="btn btn-danger btn-sm d-flex align-items-center justify-content-center p-1 ms-1"
                              onClick={() => handleDeleteProduct(i)}
                              title="Remove"
                            >
                              <Trash2 size={16} />
                            </Link>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
                <div></div>
                <div className="row p-2">
                  <div className="col-12 mb-2">
                    <label>
                      Expected Delivery Date{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="fa fa-calendar"></i>
                      </span>
                      <input
                        type="date"
                        className="form-control"
                        value={expectedDate}
                        onChange={(e) => setExpectedDate(e.target.value)}
                        min={new Date().toISOString().split("T")[0]}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-2">
                    <label>Notes</label>
                    <textarea
                      className="form-control"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      rows="2"
                      placeholder="Enter any notes here..."
                    ></textarea>
                  </div>
                  <div className="col-12 ">
                    <label>Advance Amount</label>
                    <div className="input-group">
                      <span className="input-group-text">₹</span>
                      <input
                        type="number"
                        className="form-control"
                        value={advanceAmount}
                        onChange={(e) => setAdvanceAmount(e.target.value)}
                        onWheel={(e) => e.target.blur()}
                        placeholder="0.00"
                        min="0"
                      />
                    </div>
                  </div>
                </div>
                <div className="order-total">
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Subtotal</td>
                        <td>₹{amounts?.subtotal.toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>₹{amounts?.totalTax.toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Total</strong>
                        </td>
                        <td>
                          <strong>₹{amounts.finalTotal.toFixed(2)}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="block-section payment-method">
                  <h6>Payment Method</h6>
                  <div className="row align-items-end">
                    <div className="col-sm-5">
                      <label>Payment Type</label>
                      <Select
                        className="select"
                        onChange={handlePaymentTypeChange}
                        options={paymentTypes?.map((ptypes) => ({
                          value: ptypes.Id,
                          label: ptypes.Name,
                        }))}
                        placeholder="Choose type"
                      />
                    </div>
                    <div className="col-sm-5">
                      <label>Payment Amount</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        placeholder="Enter payment amount"
                        onWheel={(e) => e.target.blur()}
                        value={currentPaymentAmount}
                        onChange={(e) =>
                          setCurrentPaymentAmount(e.target.value)
                        }
                      />
                    </div>
                    <div className="col-sm-2">
                      <label>&nbsp;</label>
                      <button
                        className="btn btn-primary w-100"
                        onClick={handleAddPayment}
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  {payments.length > 0 && (
                    <div className="payment-list mt-3">
                      <h6>Added Payments</h6>
                      {payments.map((payment, index) => {
                        const paymentTypeName =
                          paymentTypes.find(
                            (pt) => pt.Id === payment.PaymentTypeId,
                          )?.Name || "Unknown";
                        return (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-1 p-1 border"
                          >
                            <span>
                              {paymentTypeName}: ₹
                              {payment.PaidAmount.toFixed(2)}
                            </span>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleRemovePayment(index)}
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        );
                      })}
                      <hr />
                      <div className="d-flex justify-content-between">
                        <strong>Total Paid:</strong>{" "}
                        <strong>₹{totalPaid.toFixed(2)}</strong>
                      </div>
                      <div className="d-flex justify-content-between">
                        <strong>Remaining:</strong>{" "}
                        <strong>₹{remainingAmount.toFixed(2)}</strong>
                      </div>
                    </div>
                  )}
                </div>
                {/* Buttons */}
                <div className="d-flex gap-3 mt-3">
                  <button
                    className="btn btn-warning flex-fill"
                    onClick={handleAdvanceBooking}
                    disabled={
                      !advanceAmount ||
                      advanceAmount <= 0 ||
                      selectedProducts.length === 0 ||
                      loading
                    }
                  >
                    Advance Booking
                  </button>
                  <button
                    className="btn btn-success flex-fill"
                    onClick={handlePlaceOrder}
                    disabled={selectedProducts.length === 0 || loading}
                  >
                    {loading ? "Placing Order..." : "Place Order"}
                  </button>
                </div>
              </aside>
            </div>
          </div>
        </div>
        {/* Fixed Bottom Bar */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#fff",
            padding: "10px 15px",
            boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
          className="d-none"
        >
          <div className="d-flex justify-content-between align-items-center">
            <strong>Grand Total: ₹{amounts.finalTotal.toFixed(2)}</strong>
            <div>
              <button
                className="btn btn-warning me-2"
                onClick={handleAdvanceBooking}
              >
                Advance Booking
              </button>
              <button className="btn btn-success">Complete Payment</button>
            </div>
          </div>
        </div>
      </div>

      <AddCustomerModal
        isOpen={isAddCustomerOpen}
        onClose={() => setIsAddCustomerOpen(false)}
        onCustomerAdded={refetchCustomers}
      />
    </>
  );
};
export default Pos;
